import { Activity, FunctionComponent, memo, RefObject } from 'react';

import styles from '../custom-select.module.css';

import EditTextWrapper from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/edit-text-wrapper';
import { emptySpace } from '@/utils/empty-space';

type CustomSelectHeaderProps = {
  handlePreventDefaultClick: (e: React.MouseEvent<HTMLElement>) => void;
  isFocused: boolean;
  inputRef: RefObject<HTMLInputElement | null>;
  handleToggleMenu: () => void;
  RenderHeaderLabelContent?: FunctionComponent<{ selectedOptionsCount: number }>;
  selectedOptionsCount: number;
  showEditTextOnHover: boolean;
};

const CustomSelectHeader = memo(
  ({
    handlePreventDefaultClick,
    isFocused,
    inputRef,
    handleToggleMenu,
    RenderHeaderLabelContent,
    selectedOptionsCount,
    showEditTextOnHover,
  }: CustomSelectHeaderProps) => {
    return (
      <div
        className={`flex ai-center jc-space-between padding-b-4 ${styles.header}`}
        onPointerDown={handlePreventDefaultClick}
        onClick={() => {
          if (!isFocused) {
            inputRef?.current?.focus();
          } else {
            handleToggleMenu();
          }
        }}
      >
        <div className={`L2 flex-1 ${styles.headerLeft}`}>
          {RenderHeaderLabelContent ? (
            <RenderHeaderLabelContent selectedOptionsCount={selectedOptionsCount} />
          ) : (
            emptySpace
          )}
        </div>
        <Activity mode={showEditTextOnHover ? 'visible' : 'hidden'}>
          <div className={styles.headerRight}>
            <EditTextWrapper />
          </div>
        </Activity>
      </div>
    );
  }
);

CustomSelectHeader.displayName = 'CustomSelectHeader';

export default CustomSelectHeader;
